import Alert from "@amzn/meridian/esm/components/alert";
import Toaster from "@amzn/meridian/esm/components/toaster";

// Toast notifications for transient failures that aren't tied to a chat turn —
// currently the organizer agent enable/disable toggle. Each toast is
// { id, message }; the parent owns the list and removes by id on close.
const ErrorToaster = ({ toasts, onCloseToast }) => (
  <Toaster toasts={toasts} onCloseToast={onCloseToast}>
    {(toast) => (
      <Alert type="error" toast={true} size="medium" onClose={toast.onClose}>
        {toast.message}
      </Alert>
    )}
  </Toaster>
);

export default ErrorToaster;
